export default __webpack_public_path__ + "static/media/cluster.99a68399.svg";